import React from 'react';

class ToDoListItem extends React.Component {

  render(){
    let {label , eventDelete , toggleImportant , toggleDone , done=false , important=false }=this.props;
    let classNames='todo-list-item';
    let classBtnDone='';
    if(done){
      classNames+=' done';
    }
    if(important){
      classNames+=' important';
      classBtnDone+=' imp';
    }
    
  return (
      <span className={classNames}>
        <span
          className="todo-list-item-label"
          onClick={toggleDone}
          >
          {label}
        </span>
  
        <button type="button"
                className={"btn btn-outline-success btn-sm float-right todo-btn-done"+classBtnDone}
                onClick={toggleImportant}>
                  
          <i className="fa fa-exclamation" />
        </button>
  
        <button type="button"
                className="btn btn-outline-danger btn-sm float-right "
                onClick={eventDelete}
                >
          <i className="fa fa-trash-o" />
        </button>
      </span>
    );
  }
}

export default ToDoListItem;